import { render, staticRenderFns } from "./SelectableAnnotation.vue?vue&type=template&id=03f3dbe4&scoped=true"
import script from "./SelectableAnnotation.vue?vue&type=script&lang=js"
export * from "./SelectableAnnotation.vue?vue&type=script&lang=js"
import style0 from "./SelectableAnnotation.vue?vue&type=style&index=0&id=03f3dbe4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f3dbe4",
  null
  
)

export default component.exports